import { generateSrcSet, getImageVariants } from '@ori/image-sizes-helper';
import useTestId from '@ori/testid-generator';
import { useMemo } from 'react';
import { ARTICLE_BOX } from "./constants";
import { getLinkLabel } from "./getLinkLabel";
import { Category, ImageWrapper, Intro, LinkLabel, Root, Title } from "./styles";
import { LazyImage } from "../LazyImage";

/**
 * Component for displaying preview of an article and being link to it.
 * Must have `introText`, `link.relativeUrl`, `title` and `image.url` specified. Otherwise component returns `null`.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ArticleBox = function ArticleBox(_ref) {
  var labelRead = _ref.labelRead,
    labelWatch = _ref.labelWatch,
    categoryTitle = _ref.categoryTitle,
    className = _ref.className,
    image = _ref.image,
    introText = _ref.introText,
    isVideoArticle = _ref.isVideoArticle,
    link = _ref.link,
    title = _ref.title;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _ref2 = link !== null && link !== void 0 ? link : {},
    relativeUrl = _ref2.relativeUrl;
  var _ref3 = image !== null && image !== void 0 ? image : {},
    alt = _ref3.alt,
    url = _ref3.url;
  var imagesVariants = useMemo(function () {
    return {
      url: url !== null && url !== void 0 ? url : '',
      backgroundColor: '#f5f5f5',
      params: [{
        width: 231,
        quality: 90
      }, {
        width: 328,
        quality: 80
      }, {
        width: 480,
        quality: 70
      }, {
        width: 567,
        quality: 60
      }, {
        width: 720,
        quality: 50
      }]
    };
  }, [url]);
  if (!introText || !relativeUrl || !title || !url) {
    return null;
  }
  var images = getImageVariants(imagesVariants);
  return /*#__PURE__*/_jsxs(Root, {
    className: className,
    "data-testid": getTestId(ARTICLE_BOX),
    href: relativeUrl,
    children: [/*#__PURE__*/_jsx(ImageWrapper, {
      children: /*#__PURE__*/_jsx(LazyImage, {
        srcSet: generateSrcSet(images),
        alt: alt !== null && alt !== void 0 ? alt : url
      })
    }), categoryTitle ? /*#__PURE__*/_jsx(Category, {
      children: categoryTitle
    }) : undefined, /*#__PURE__*/_jsx(Title, {
      as: "h3",
      children: title
    }), /*#__PURE__*/_jsx(Intro, {
      as: "p",
      children: introText
    }), /*#__PURE__*/_jsx(LinkLabel, {
      children: getLinkLabel({
        labelRead: labelRead,
        labelWatch: labelWatch,
        isVideoArticle: isVideoArticle,
        link: link
      })
    })]
  });
};
//# sourceMappingURL=ArticleBox.js.map